module.exports = __webpack_public_path__ + "img/icon_emotion_panel.2x49d02c.1f2b5876.png";